import memoize from 'fast-memoize'

const mirror = obj => obj
export const memMirror = memoize(mirror)

export const createCancellableCallback = (fn) => {
  let isCancelled = false
  const _fn = (...args) => {
    if (!isCancelled) fn(...args)
  }
  _fn.cancel = (...args) => {
    isCancelled = true
  }
  return _fn
}

export { memoize }
